import { jsx as _jsx } from "react/jsx-runtime";
import { useNextRouterContext } from "@faire/retailer-visitor-shared/app/_lib/routing/NextRouterContext";
import { LeanBrandTileRendererForCarouselBase } from "@faire/retailer-visitor-shared/components/LeanBrandTileRenderer/__internal__/LeanBrandTileRendererForCarouselBase";
import { SignUpElement } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { brandPage } from "@faire/retailer-visitor-shared/paths/index";
import { useSettingBrandLinkHoverThreshold } from "@faire/retailer-visitor-shared/settings/getSettingBrandLinkHoverTheshold";
import { getSettingRscLibp } from "@faire/retailer-visitor-shared/settings/getSettingRscLibp";
import { Column } from "@faire/web--source/slate/Layout";
import { useObservable } from "@faire/web--source/ui/hooks/useObservable";
import { PrefetchKind } from "next/dist/client/components/router-reducer/router-reducer-types";
import * as React from "react";
export var LeanBrandTileRendererForCarousel = function(param) {
    var onClick = param.onClick, leanBrandTile = param.leanBrandTile, brandPageQueryParams = param.brandPageQueryParams, bottomPadding = param.bottomPadding, showMinimum = param.showMinimum, signUpSourceId = param.signUpSourceId, signUpElement = param.signUpElement;
    var token = useObservable(function() {
        var _leanBrandTile_brand;
        return leanBrandTile === null || leanBrandTile === void 0 ? void 0 : (_leanBrandTile_brand = leanBrandTile.brand) === null || _leanBrandTile_brand === void 0 ? void 0 : _leanBrandTile_brand.token;
    });
    var PREFETCH_DELAY_MS = useSettingBrandLinkHoverThreshold();
    var timeoutRef = React.useRef(undefined);
    var _useNextRouterContext = useNextRouterContext(), nextPrefetch = _useNextRouterContext.prefetch;
    var isRSCBrandPage = getSettingRscLibp();
    var handleClick = function() {
        clearTimeout(timeoutRef.current);
        if (onClick && token) {
            onClick(token);
        }
    };
    var handleFocus = function() {
        timeoutRef.current = setTimeout(function() {
            if (isRSCBrandPage) {
                if (token) {
                    nextPrefetch(brandPage(token), {
                        kind: PrefetchKind.FULL
                    });
                }
            }
        }, PREFETCH_DELAY_MS);
    };
    var handleBlur = function() {
        clearTimeout(timeoutRef.current);
    };
    return /*#__PURE__*/ _jsx(Column, {
        style: {
            height: "100%"
        },
        "data-test-id": "lean-brand-tile-renderer-onclick-container-".concat(token),
        onClick: handleClick,
        onMouseEnter: handleFocus,
        onMouseLeave: handleBlur,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onTouchStart: handleFocus,
        children: /*#__PURE__*/ _jsx(LeanBrandTileRendererForCarouselBase, {
            brandTile: leanBrandTile,
            brandPageQueryParams: brandPageQueryParams,
            bottomPadding: bottomPadding,
            showMinimum: showMinimum,
            signUpTracking: {
                element: signUpElement !== null && signUpElement !== void 0 ? signUpElement : SignUpElement.CAROUSEL,
                sourceId: "".concat(signUpSourceId)
            }
        })
    });
};
